import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CodeActiviteService {

  PPC: Array<string> = ['PPC'];

  O2: Array<string> = [
    "O2COV",
    "O2 CT",
    "O2 DY",
    "O2 LI",
    "O2LIS",
    "O2 LT",
    "O2 SA",
  ];

  VENTILATION: Array<string> = [
    "OHD",
    "REHAB",
    "VENTI",
    "VENTX",
  ];

  FORFAITS_ASSOCIES_PPC: Array<string> = [
    "O2PPC",
  ];

  FORFAITS_ASSOCIES_VNI: Array<string> = [
    "O2VNI",
  ];

  AEROSOLS: Array<string> = ["AE"];

  AVF: Array<string> = ["O2 AV"];

  constructor() { }
}
